export default "__VITE_ASSET__GH79JGow__"